<div class="isg-daterange">
  <kendo-dropdownlist #dateRangeType
                      class="isg-dateRangeType"
                      [data]="_rangeList"
                      defaultItem="-- Select date range --"
                      [value]="dateRangeTypeValue"
                      (valueChange)="dateRangeTypeValueChange($event)">
  </kendo-dropdownlist>
  <kendo-datepicker #dateFrom
                    class="isg-dateFrom"
                    [disabled]="datePickersDisable"
                    format="dd MMM yyyy"
                    placeholder="from"
                    [value]="startDate"
                    (valueChange)="startDateChange($event)">
  </kendo-datepicker>
  <kendo-label class="isg-lbl" text="-" [for]="dateTo">
  </kendo-label>
  <kendo-datepicker #dateTo
                    class="isg-dateTo"
                    [disabled]="datePickersDisable"
                    format="dd MMM yyyy"
                    placeholder="to"
                    [value]="endDate"
                    (valueChange)="endDateChange($event)">
  </kendo-datepicker>
</div>
